import {
  Component,
  OnInit,
  Renderer2,
  ViewChild,
  ElementRef,
  ChangeDetectorRef,
  Inject
} from '@angular/core';
import {
  UserService,
  LoaderService,
  AppDataSharingService,
  DataStorageService,
  debounce
} from '@pulse/common';
import { Router } from '@angular/router';
//import { LoaderService } from './core/loader.service';
import { SEGMENT_ANALYTICS_CONSTANTS } from '@pulse/common';
import { Store } from '@ngrx/store';
import { IAppState } from '@pulse/common';
import { ToggleFilterPanel } from '@pulse/common';
import { AppConfigService, capabilites, FolderBrowserWidgetNewService, getOtdsToken } from '@pulse/common';
import { Constatnts } from '../assets/constants/constants';
import { TranslateService } from "@ngx-translate/core";
import { datadogRum } from '@datadog/browser-rum';
import { UEMSurveyService } from './uem-survey.service'
import { SubSink } from 'subsink';
import { MyProfileService } from './profile/my-profile/my-profile-component/my-profile.service';
import { AppLoadService } from './app-load.service';
import { DOCUMENT } from '@angular/common';
import { ScrollService } from './core/scroll.service';
declare var analytics;

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss']
})
export class AppComponent implements OnInit {
  public isMobile: boolean;
  public screenSize = window.screen.availWidth;
  public isLoaderVisible: boolean = false;
  public isMenuCollapsed: boolean = false;
  public isAgreementsEmpty: boolean = true;
  public hasUserInfo: boolean = false;
  public CSUILoaded: boolean = false;
  userAgrement: boolean = false;
  public mobileNav: boolean = false;
  csWidgetJsUrl: string;
  readonly INVALID_USER = 'Invalid user. Not have Privilages to application';
  toggleFilterPanel: boolean;
  @ViewChild('scrollWrapper') private scrollContainer: ElementRef;
  killSwitches: any;
  hideChatBot: boolean = false;
  agreements: any = [];
  showAddContactModalFlag = false;
  showAddDateModalFlag = false;
  showAddDocModalFlag = false;
  showAddpropertyGroupModalFlag = false;
  isTranslateLoaded: boolean = false;
  enablePropertyFilter: boolean = true;
  overFlowMainContainer: boolean = false;
  subs = new SubSink();

  propertyFilterCapabilities = [
    capabilites.CONTACTS,
    capabilites.CRITICALDATES,
    capabilites.DASHBOARD,
    capabilites.DOCUMENTS,
    capabilites.BIMETRICS,
    capabilites.BIANALYTICS,
    capabilites.PROPERTYDETILAS,
  ];
  showOldLoader = false;
  @ViewChild('mainDiv') mainDiv!: ElementRef;

  constructor(
    private userService: UserService,
    public router: Router,
    private loaderService: LoaderService,
    private appDataSharingService: AppDataSharingService,
    private renderer: Renderer2,
    private store: Store<IAppState>,
    private configService: AppConfigService,
    private cdRef: ChangeDetectorRef,
    private translate: TranslateService,
    private dataStorageService: DataStorageService,
    private uemSurveyService: UEMSurveyService,
    private folderWidgetService: FolderBrowserWidgetNewService,
    private preferenceService: MyProfileService,
    private appLoadService: AppLoadService,
    private scrollService: ScrollService,
    @Inject(DOCUMENT) private document: Document
  ) {
    this.renderer.addClass(document.body, 'hide-loader');
    this.csWidgetJsUrl = configService.get('cs_widget_js_url');
    this.killSwitches = this.configService.get('killSwitches');
    if (this.killSwitches && this.killSwitches.chatbot) {
      this.hideChatBot = this.killSwitches.chatbot;
    }
    this.initializeDataDog();
    this.initializeSegment();

  }
  initializeSegment() {
    try {
      const script = this.renderer.createElement('script');
      let environment = this.configService.environment;
      let _src = "./assets/nonProdSegment.js";
      if (environment == "prod") {
        _src = "./assets/prodSegment.js";
      }
      script.src = _src;
      this.renderer.appendChild(this.document.body, script)
      this.logSegment();
    }
    catch (e) {
      console.log(e)
    }
  }

  ngOnInit() {
    this.translate.use(this.userService.getLanguage()).subscribe(
      (res) => {
        this.isTranslateLoaded = true;
      }, err => {
        this.translate.setDefaultLang(this.userService.getLanguage());
        this.isTranslateLoaded = true;
      });
    this.screenSize <= 414 ? (this.isMobile = true) : (this.isMobile = false);
    this.validateUser();
    this.validatePropertyFilterNav();
    this.loaderService.isLoaderVisible.subscribe((obj: any) => {
      if (obj && obj.value) {
        this.showOldLoader = obj.showOldLoader;
      }
      this.isLoaderVisible = obj.value;
    });
    this.appDataSharingService.isMenuCollapsed.subscribe(value => {
      this.isMenuCollapsed = value;
      this.cdRef.detectChanges();
    });
    this.appDataSharingService.isUserInfoAvailable.subscribe(value => {
      if (!this.hasUserInfo && value) {
        this.hasUserInfo = value;
        const user = this.userService.getUserInfo();
        if (user.eligibleForUEMSurvey) {
          this.uemSurveyService.init()
        }
        if (this.CSUILoaded == true) {
          this.preLoadDocumentsFolder();
        }
      }
    });

    this.preferenceService.languageChangeBehaviourSubject.subscribe(res => {
      if (res) {
        this.preLoadDocumentsFolder();
      }
    })

    this.appDataSharingService.resetScrollToTop.subscribe(value => {
      this.scrollContainer.nativeElement.scrollTop = 0;
    });
    this.appDataSharingService.isAgreementsEmpty.subscribe(value => {
      if (value) {
        this.isAgreementsEmpty = value;
      }
    });

    this.appDataSharingService.overflowMainContainer.subscribe(value => {
      this.overFlowMainContainer = value;
    })


    this.appDataSharingService.openNewContactDialog.subscribe(value => {
      if (value) {
        this.toggleAddContactModal();
      }
    });

    this.appDataSharingService.openNewDocumentDialog.subscribe(value => {
      if (value) {
        this.toggleAddDocModal();
      }

    });

    this.appDataSharingService.openNewCriticalDateDialog.subscribe(value => {
      if (value) {
        this.toggleAddDateModal();
      }

    });

    this.appDataSharingService.openNewGroupDialog.subscribe(value => {
      if (value) {
        this.toggleAddPropertyGroupModal();
      }
    });

    this.appDataSharingService.navigateToPage.subscribe(value => {
      if (value) {
        this.router.navigate(Array.isArray(value) ? value : [value])
      }
    });

    // subs for toggling the panel
    this.store
      .select(state => state.overview)
      .subscribe(({ isFilterPanelOpened }) => {
        this.toggleFilterPanel = isFilterPanelOpened;
      });

    this.appDataSharingService.sideNavCollapseSubject.subscribe(data => {
      if (data && data.menu) {
        this.mobileNav = true;
      }
    });
    this.scrollService.scrollToPosition$.subscribe((position: number) => {
      this.scrollToPosition(position);
    });

    this.scrollService.storeScroll$.subscribe((position: number) => {
      const scrollY = this.mainDiv.nativeElement.scrollTop;
      this.scrollService.setScrollPosition(scrollY);
    });
  }

  scrollToPosition(position: number): void {
    if (this.mainDiv) {
      this.mainDiv.nativeElement.scrollTo({
        top: position,
        behavior: 'smooth' // Smooth scrolling
      });
    }
  }

  preLoadDocumentsFolder() {
    this.subs.add(
      this.store.select(getOtdsToken).subscribe((token) => {
        if (token && token !== "loading") {
          this.folderWidgetService.preLoadDocumentsAssets();
        } else if (!token) {
          this.folderWidgetService.noAccessToDocuments = true;
        }
      })
    );
  }

  onCSScriptLoadedEvent(val) {
    if (val) {
      if (this.hasUserInfo)
        this.preLoadDocumentsFolder();
      else {
        this.CSUILoaded = true;
      }
    }
  }

  getExludeUrls() {
    const excludeUrls = [];

    let notifUrl = this.configService.getApi('globalNnotification') + 'mobileNotification/fetchNotifications';
    let otCSTicket = this.configService.getApi('globalDocumentsAPI') + 'document/GetUserOTCSTicket';

    excludeUrls.push(notifUrl);
    excludeUrls.push(otCSTicket);

    return excludeUrls
  }

  initializeDataDog() {
    const datadogConf = this.configService.get('datadog');
    if (datadogConf) {
      datadogRum.init({
        ...datadogConf,
        site: 'datadoghq.com',
        service: 'global-pulse',
        env: this.configService.environment,
        sessionSampleRate: 100,
        sessionReplaySampleRate: 50,
        trackUserInteractions: true,
        trackResources: true,
        trackLongTasks: true,
        defaultPrivacyLevel: 'mask-user-input',
        excludedActivityUrls: this.getExludeUrls()
      });
      datadogRum.setGlobalContextProperty('cbre_details', {
        tower: 'boe',
        lob: 'propertymanagement',
        application: 'global-pulse',
        apm_id: 660788,
        apm_no: 'APM0001693'
      });
      datadogRum.setUser({
        name: this.userService.getUserName(),
        email: this.userService.getUserEmail()
      });
      datadogRum.startSessionReplayRecording();
    }
  }



  @debounce(1000)
  logSegment() {
    const segmentLoggedIn = this.dataStorageService.readFromSessionStorage('segmentLoggedIn');
    let email = this.userService?.getUserInfo()?.email;

    if (!segmentLoggedIn) {
      if (email) {
        this.appLoadService.setSegmentUUID().subscribe((res: any) => {
          let useName = this.userService.getUserName();
          let userInfo = this.userService.getUserInfo();
          try {
            if (analytics) {
              analytics.identify(res, {
                name: useName,
                email: email,
                role: userInfo?.roleName || "",
                countryId: userInfo?.countryId || "",
                regionId: userInfo?.regionID || ""
              });
              analytics.track(SEGMENT_ANALYTICS_CONSTANTS.Analytics_Event_Categories.LOGGED_IN, { message: SEGMENT_ANALYTICS_CONSTANTS.Analytics_Event_Labels.LOGGED_IN })
              this.dataStorageService.writeToSessionStorage('segmentLoggedIn', true);
            }
          }
          catch (e) { }
        });
      }
    }
  }

  validatePropertyFilterNav() {
    try {
      let _flag = this.userService.userInfo.features.some(i => this.propertyFilterCapabilities.includes(i.capability))

      this.enablePropertyFilter = _flag
    } catch (e) {

    }
  }

  toggleAddContactModal() {
    this.showAddContactModalFlag = !this.showAddContactModalFlag;
    // this.templateName = 'createContact';
  }
  toggleAddDateModal() {
    this.showAddDateModalFlag = !this.showAddDateModalFlag;
  }
  toggleAddPropertyGroupModal() {
    this.showAddpropertyGroupModalFlag = !this.showAddpropertyGroupModalFlag;
  }
  toggleAddDocModal() {
    this.showAddDocModalFlag = !this.showAddDocModalFlag;
  }

  validateUser() {
    if (localStorage.getItem('VALID_USER_SESSION')) {
      if ((
        !this.userService.userInfo ||
        this.userService.userInfo.message === this.INVALID_USER ||
        !this.userService.userInfo.accessToken
      )) {

        this.router.navigate(['unauthorized']);
      } else if (this.userService.userInfo.agreements) {
        this.handleAgreements();
      } else {
        const url = this.appDataSharingService.getRedirectUrl() || this.dataStorageService.readFromSessionStorage('postLoginURL');
        if (url) {
          this.router.navigateByUrl(url);
          this.appDataSharingService.setRedirectUrl("");
          this.dataStorageService.removeToSessionStorage('postLoginURL');
        } else {
          const defaultLanding = this.dataStorageService.readFromSessionStorage('defaultLandingPage');
          if (defaultLanding) {
            this.router.navigate([defaultLanding]);
          } else if (this.router.url === '/marketing' || this.router.url === '/') {
            this.router.navigate(['/properties/dashboard']);
          }
        }
      }
    }
    else {
      this.router.navigate(['/marketing']);
    }
  }

  handleAgreements() {
    const agreements = this.userService.userInfo.agreements;
    const landingPageAgreements = agreements.filter(agreement => agreement.page_name === "landing");
    if (landingPageAgreements.length > 0) {
      this.isAgreementsEmpty = false;
      this.router.navigate([Constatnts.AGREEMENT_ROUTE])
    }
  }


  unmaskPage() {
    this.toggleFilterPanel = false;
    this.store.dispatch(new ToggleFilterPanel(false));
  }

  mobNavClose(data) {
    if (!data) {
      this.mobileNav = false;
    }
  }
}